export default __webpack_public_path__ + "static/media/FemaleHeadLeft.5b37de5b.png";